export function initHeroVideo() {
  const video = document.getElementById("hero-video");
  if (!video) return;

  video.addEventListener("mouseenter", () => { video.controls = true; });
  video.addEventListener("mouseleave", () => { video.controls = false; });
  video.addEventListener("focus", () => { video.controls = true; });
  video.addEventListener("blur", () => { video.controls = false; });

  const mq = window.matchMedia("(prefers-reduced-motion: reduce)");

  function applyMotionPreference() {
    if (mq.matches) {
      video.pause();
      video.controls = true;
    }
  }

  applyMotionPreference();
  mq.addEventListener("change", applyMotionPreference);
}
